import { eur } from "@/components/excelVoce/format";
import { TIPO_LABEL } from "./labels";

const Card1 = ({ label, c, testid, strong }) => {
  const sc = Number(c.scostamento);
  const nd = c.scostamento === null;
  return (
    <div className={`rounded-md border p-3 ${strong ? "border-amber-300 bg-amber-50/50 dark:bg-amber-950/20" : ""}`} data-testid={testid}>
      <div className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold">{label}</div>
      <div className="mt-2 grid grid-cols-2 gap-1 text-xs">
        <span className="text-slate-500">Previsto</span><span className="font-mono text-right" data-testid={`${testid}-previsto`}>{eur(c.previsto)}</span>
        <span className="text-sky-700">Effettivo{nd ? " determinato" : ""}</span><span className="font-mono text-right text-sky-800" data-testid={`${testid}-effettivo`}>{eur(c.effettivo)}</span>
        {nd && <><span className="text-rose-700">Da determinare</span><span className="font-mono text-right text-rose-700" data-testid={`${testid}-da-determinare`}>{c.da_determinare} quote</span></>}
        <span className="text-slate-500">Scostamento</span>
        {nd ? <span className="text-right text-xs text-slate-500" data-testid={`${testid}-scostamento-nd`}>non calcolabile</span>
          : <span className={`font-mono text-right font-semibold ${sc > 0.004 ? "text-rose-700" : "text-emerald-700"}`}>{sc > 0 ? "+" : ""}{eur(c.scostamento)}</span>}
      </div>
    </div>
  );
};

export const ConfrontoCards = ({ confronto, testid = "confronto" }) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-2" data-testid={testid}>
    {["materiali", "manodopera", "noli"].map((k, i) => <Card1 key={k} label={TIPO_LABEL[["MATERIALE", "MANODOPERA", "NOLO"][i]]} c={confronto[k]} testid={`${testid}-${k}`} />)}
    <Card1 label="Totale costi" c={confronto.totale} testid={`${testid}-totale`} strong />
  </div>
);
